import React, { useEffect } from 'react';
import { ReferralContextProvider } from './context';
import {
  createBatchEventProcessor,
  createInstance,
  createPollingProjectConfigManager,
  OptimizelyProvider
} from '@optimizely/react-sdk';
import {
  getAuthenticationTaggedUrl,
  getUniqueSessionUserId,
  optimizelyKey,
  recaptchaKeyV3
} from '../../shared/utils';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { trackPageViewed } from '../../shared/analytics';
import { ReferralForm } from './components';
import {
  useLoadZenDesk,
  useTrackFullPageFormExperiment
} from '../../shared/hooks';

const optimizely = createInstance({
  projectConfigManager: createPollingProjectConfigManager({
    sdkKey: optimizelyKey(),
    autoUpdate: true
  }),
  eventProcessor: createBatchEventProcessor()
});

function useTrackReferralPageViewed() {
  useEffect(() => {
    getAuthenticationTaggedUrl().then((url) => {
      trackPageViewed({
        name: 'ramsey_tax_advisor_referral',
        title: 'RamseyTrusted Tax Advisors | RamseySolutions.com',
        keywords: ['tax', 'referral', 'advisor', 'form'],
        ...(url ? { url } : {})
      });
    });
  }, []);
}

function App() {
  useTrackReferralPageViewed();
  useLoadZenDesk();
  useTrackFullPageFormExperiment();

  return (
    <React.StrictMode>
      <ReferralContextProvider>
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaKeyV3()}>
          <OptimizelyProvider
            client={optimizely}
            timeout={5000}
            user={{
              id: getUniqueSessionUserId(),
              attributes: { userId: getUniqueSessionUserId() }
            }}
          >
            <ReferralForm />
          </OptimizelyProvider>
        </GoogleReCaptchaProvider>
      </ReferralContextProvider>
    </React.StrictMode>
  );
}

export { App };
